import {upperFirst} from "@pg-mono/nodash";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";

interface IProps {
    regionNameDeclensionWhere: string;
    offerCountForSale: number;
    propertiesCountForSale: number;
    offerTypeName: string;
}

export const getOfferToSaleSummarySectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    return [
        {
            type: ParagraphType.TEXT,
            text: `${upperFirst(variables.regionNameDeclensionWhere)} ${pluralize([
                `dostępna jest ${numberFormat(variables.propertiesCountForSale)} oferta ${variables.offerTypeName} znajdująca`,
                `dostępne są ${numberFormat(variables.propertiesCountForSale)} oferty ${variables.offerTypeName} znajdujące`,
                `dostępnych jest ${numberFormat(variables.propertiesCountForSale)} ofert ${variables.offerTypeName} znajdujących`
            ])(variables.propertiesCountForSale)} się w ${pluralize([
                `${numberFormat(variables.offerCountForSale)} inwestycji deweloperskiej`,
                `${numberFormat(variables.offerCountForSale)} inwestycjach deweloperskich`,
                `${numberFormat(variables.offerCountForSale)} inwestycjach deweloperskich`
            ])(variables.offerCountForSale)}.`
        }
    ];
};
import {upperFirst} from "@pg-mono/nodash";
import {numberFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ParagraphType} from "../constants";

interface IProps {
    regionNameDeclensionWhere: string;
    offerCountForSale: number;
    propertiesCountForSale: number;
    offerTypeName: string;
}

export const getOfferToSaleSummarySectionTexts = (variables: IProps): ILocationGenericSection["paragraphs"] => {
    return [
        {
            type: ParagraphType.TEXT,
            text: `${upperFirst(variables.regionNameDeclensionWhere)} ${pluralize([
                `dostępna jest ${numberFormat(variables.propertiesCountForSale)} oferta ${variables.offerTypeName} znajdująca`,
                `dostępne są ${numberFormat(variables.propertiesCountForSale)} oferty ${variables.offerTypeName} znajdujące`,
                `dostępnych jest ${numberFormat(variables.propertiesCountForSale)} ofert ${variables.offerTypeName} znajdujących`
            ])(variables.propertiesCountForSale)} się w ${pluralize([
                `${numberFormat(variables.offerCountForSale)} inwestycji deweloperskiej`,
                `${numberFormat(variables.offerCountForSale)} inwestycjach deweloperskich`,
                `${numberFormat(variables.offerCountForSale)} inwestycjach deweloperskich`
            ])(variables.offerCountForSale)}.`
        }
    ];
};
